export default __webpack_public_path__ + "static/cli_maxiahorro-266696aaf3a8454b8149eacb145b8be5.png";